// extracted by mini-css-extract-plugin
module.exports = {"text":"inlineDonut_text__20LxI","withSubtitle":"inlineDonut_withSubtitle__1_D-Z","subtitle":"inlineDonut_subtitle__ah2xf"};